export const vttCompatibleLevels: string[] = [
  'Roll20',
  'Foundry Virtual Tabletop',
  'Fantasy Grounds',
  'D&D Beyond',
  'Owlbear Rodeo',
  'Alchemy RPG',
  'Tabletop Simulator',
  'TaleSpire',
  'Astral TableTop',
  'Shard Tabletop',
  'Other (Map & PDF Only)'
];
